import { createContext, FC, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getTotalCreditsByDashboardType } from "../../../api/broker";
import {
  BarFilters,
  CreditosOrganizacion,
  initalBarFilters,
} from "../../../interfaces/SuperAdmin/Pages/iDataCreditos";
import { DashboardType } from "../../../interfaces/SuperAdmin/Pages/iDataDashboard";

interface AllOrgsDashboardContextProps {
  totalCredits: CreditosOrganizacion[];
  isLoadingCredits: boolean;
  totalCreditsFilters: BarFilters
  handleToggleCredit: (value: string) => void
}

const AllOrgsDashboardContext = createContext<AllOrgsDashboardContextProps>(
  {} as AllOrgsDashboardContextProps
);

interface Props {
  children: React.ReactNode;
}

const AllOrgsDashboardProvider: FC<Props> = ({ children }) => {
  // credits tendrá los créditos, y el tipo dependerá de qué filtro tenga
  const [totalCredits, setTotalCredits] = useState<CreditosOrganizacion[]>([]);
  const [isLoadingCredits, setIsLoadingCredits] = useState(true);
  const [totalCreditsFilters, setTotalCreditsFilters] = useState<BarFilters>(initalBarFilters);

  // Fetch de creditos totales de todas las organizaciones
  const fetchCreditos = async () => {
    setIsLoadingCredits(true);
    try {
      const res = await getTotalCreditsByDashboardType(
        DashboardType.ALL_ORGS,
        {}
      );
      console.log(res);
      if (res.data.statusCode === 200) {
        setTotalCredits(res.data.body as CreditosOrganizacion[]);
      } else {
        toast.error("Error al obtener los créditos totales");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error al obtener los créditos totales");
    } finally {
      setIsLoadingCredits(false);
    }
  };

  // Función para cambiar filtros
  const handleToggleCredit = (value: string) => {
    setTotalCreditsFilters((prev) => ({
      ...prev,
      credits: prev.credits.map((credit) =>
        credit.value === value
          ? { ...credit, isActive: !credit.isActive }
          : credit
      ),
    }));
  };

  // Ejecutamos el fetch al montar el componente
  useEffect(() => {
    fetchCreditos();
  }, []);

  return (
    <AllOrgsDashboardContext.Provider
      value={{ totalCredits, isLoadingCredits, totalCreditsFilters, handleToggleCredit }}
    >
      {children}
    </AllOrgsDashboardContext.Provider>
  );
};

const useAllOrgsDashboard = () => useContext(AllOrgsDashboardContext);

export { AllOrgsDashboardProvider, useAllOrgsDashboard };

